import { json, LoaderFunctionArgs, type LinksFunction } from '@remix-run/node';
import { useLoaderData, useNavigate } from '@remix-run/react';
import { deleteWorkApi } from '~/ajax/api.client';
import { Empty } from '~/components/awards2024/Empty';
import Awards2024LoginPrompt from '~/components/awards2024/login-prompt';
import { useToast } from '~/components/toast';
import { getFlowDatumData, getRouteOption } from '~/data/awards2024/config';
import { getMysHandler } from '~/handlers/getMys.servert';
import { getAuthInfo } from '~/helpers/auth.server';
import { useRevalidate } from '~/hooks/useRevalidate';
import { setWarnPromatDialog } from '~/signalsAndContext/global';
import stylesIndex from '~/styles/awards2024/myWork.css';

export const links: LinksFunction = () => [
{
  rel: 'stylesheet',
  href: stylesIndex
}];


export async function loader(args: LoaderFunctionArgs) {
  const userInfo = await getAuthInfo(args.request);
  if (!userInfo) {
    return json({ userInfo: null, works: [], isLogin: false });
  }

  try {
    const res = await getMysHandler({
      user: userInfo, req: args.request,
      context: args.context, body: {}, query: {}
    });
    if (res.code === 0) {
      return json({ userInfo: res.data.userInfo, works: res.data.entryList || [], isLogin: true });
    }
    return json({ userInfo, works: [], isLogin: true });
  } catch (error) {
    console.error(error);
    return json({ userInfo, works: [], isLogin: true });
  }
}

export default function Awards2024MyWorkPage() {
  const navigate = useNavigate();
  const { works, userInfo, isLogin } = useLoaderData<typeof loader>();
  const revalidate = useRevalidate();
  const matchCurrentStage = getFlowDatumData().current;
  const toast = useToast();
  const handleDeleteWork = (id: number) => {
    setWarnPromatDialog({
      onConfirm: async () => {
        const res = await deleteWorkApi(id);
        if (res.code !== 0) {
          toast.error(`Delete Error: ${res.msg}`);
          return;
        }
        toast.success('Delete Success');
        revalidate();
      },
      renderContent: () => <p className='promat-tips'>Are you sure you want to delete the current game information? It cannot be restored after deletion.</p>
    });
  };

  const handleEditPersonalInfo = () => {
    navigate('/awards2024/applyForm/user', getRouteOption());
  };

  const renderMain = () => <main className='form-page-main'>
    <div className="my-works__wrap">
      <div className="my-works__tab">
        <button type='button' className="my-works__tab-link my-works__tab-link--cur">ALL</button>
        <button type='button' className="btn-personal" onClick={handleEditPersonalInfo}>Personal<br />Information</button>
      </div>
      <div className='my-works__list'>
        {

        works.length > 0 && works.map((item) => <div className='my-works__item'>
            <div className="my-works__item-poster">
              <img src={item?.iconUrl} />
            </div>
            <div className="my-works__item-info">
              <p className="my-works__item-title">{item?.gameName}</p>
              <div className="my-works__item-del">
                {/* <span className="my-works__item-status">item-state</span> */}
                <div className="my-works__item-handle">
                  <button type='button' className="edit" disabled={matchCurrentStage !== 1} onClick={() => {
                  navigate(`/awards2024/applyForm/work/${item?.entryId}`, getRouteOption());
                }}>EDIT</button>
                  <span className="split">|</span>
                  <button type='button' className="delete" disabled={matchCurrentStage !== 1} onClick={
                () => {
                  handleDeleteWork(item?.entryId || 0);
                }
                }>DELETE</button>
                </div>
              </div>
            </div>
          </div>)
        }
        {
        matchCurrentStage === 1 && <div className="my-works__item my-works__new" onClick={() => {
          if (!userInfo?.email) {
            toast.warn('Please complete your personal information first');
            return;
          }
          navigate('/awards2024/applyForm/work', getRouteOption());
        }}>
            <i className="icon-new" />
            <span className="text-new">NEW</span>
          </div>
        }
      </div>
      {
      works.length === 0 && <Empty nonIcon={true}
      msg={'In the collection of works, please look forward to the creativity of the contestants'} />
      }
    </div>
  </main>;

  return <div className='form-page my-works'>
    {
    !isLogin ? <Awards2024LoginPrompt /> : renderMain()
    }
  </div>;
}